<template>
    <div>
        <item-write-link v-for="writeLayout in writeLayouts" :key="`itemComp${writeLayout}`"
                         :writeLayout="writeLayout" :itemData="itemData"></item-write-link>
    </div>
</template>

<script>
import ItemWriteLink from "@/components/item/ItemWriteLink";
import itemUtil from "@/components/item/itemUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
import itemValidator from "@/mixins/validators/itemValidator";

export default {
    name: "ItemWriteCollectionComponent",
    mixins: [itemUtil, alertMixins, awsS3FileUpload, itemValidator],
    components: {ItemWriteLink},
    provide() {
        return {
            itemWriteSetData: this.setData
        }
    },
    inject: ['changeLoading'],
    props: {
        itemType: {default: ''},
        itemKey: {default: ''},
    },
    data() {
        return {
            itemData: {},

            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            fileInfo: [],
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: '',
            writeFailTypes: {},
            deleteFunc: '',

            getFunc: '',
            detailApiParamSet: {},

            title: '',
            intro: '',
            owner: '',
            backImg: [],
            mainImg: [],
        }
    },
    created() {
        this.initConfig();
    },
    mounted() {
        EventBus.$on('writeCollection', this.checkValidator)
    },
    beforeDestroy() {
        EventBus.$off('writeItem')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let configItem = this.returnItemConfig(this.itemType);
            this.writeLayouts = configItem.writeLayouts;
            this.getFunc = configItem.getFunc;
            this.detailApiParamSet = configItem.detailApiParamSet
            this.writeFunc = configItem.writeFunc;
            this.writeApiParamSet = configItem.writeApiParamSet;
            this.parsingData = configItem.parsingData;
            this.fileInfo = configItem.fileInfo;
            this.directUrl = configItem.directUrl;
            this.directType = configItem.directType;
            this.writeSuccessType = configItem.writeSuccessType;
            this.keyName = configItem.keyName;
            this.writeFailTypes = configItem.writeFailTypes;
            this.writeValidatorArr = configItem.writeValidatorArr;
            this.afterType = configItem.afterType;
            this.successMsg = configItem.successMsg;
            this.getCollection();
        },
        getCollection() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamSet))
            params[this.keyName] = this.itemKey

            this.$api.$item[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type !== 1) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.itemData = res.List[0];
                if (!util.isEmpty(res.Log)) {
                    this.itemData.Log = res.Log;
                }
            })
        },
        checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
            this.$validate(validatorArr).then(success => {
                if (success) {
                    this.writeItem();
                } else {
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    })
                }
            })
        },
        writeItem() {
            EventBus.$emit('apiLoading', true);
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
            let dataArr = Object.keys(this.parsingData);
            dataArr.forEach(dataKey => {
                params[this.parsingData[dataKey]] = this[dataKey];
            })
            params.c_idx = this.itemKey;
            try {
                this.$api.$item[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type !== 1) {
                        EventBus.$emit('apiLoading', false);
                        this.errorAlert('컬렉션 수정에 실패하였습니다');
                        return false;
                    } else {
                        if (!util.isEmpty(this.deleteFiles)) {
                            this.runS3ApiDeleteFiles(this.deleteFiles)
                        }
                        this.setMultiFileUpload(this.itemKey, this.fileInfo);
                    }

                });

            } catch (e) {
                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
                console.log(e);
            }
        },
        setMultiFileUpload(key, fileInfo) {
            if (Array.isArray(key)) {
                util.Array.each(key, (data, index, arr) => {
                    this.runUploadFileInfo(fileInfo, 0, data).then(res => {
                        if (key.length === index + 1) {
                            this.writeAfterFunc();
                        }
                    })
                });
            } else {
                this.runUploadFileInfo(fileInfo, 0, key).then(res => {
                    this.writeAfterFunc();
                })
            }
        },
        writeAfterFunc() {
            EventBus.$emit('apiLoading', false);
            this.createAlert({
                content: '저장되었습니다.',
                hide: () => {
                    this.$router.push('/item/collection');
                }
            });
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
